const isDefined = require('mn-utils/isDefined');


module.exports = (input, limit) => {
  isDefined(limit) || (limit = 10);
  input = input || '';
  const partSize = Math.floor(limit * 0.5);
  const length = input.length;
  return length > limit
    ? (
      input.substr(0, partSize) + '...'
        + input.substr(length - partSize, partSize)
    ) : input;
};
